import { Component, ElementRef, OnInit } from '@angular/core';
import { Log } from '@s8l/client-tree-lib';

import { MetricAttrMap, StatsService } from 'src/app/services/stats.service';

import { TableWidgetComponent } from '../table-widget/table-widget.component';

@Component({
  selector: 'app-multi-table-widget',
  templateUrl: './multi-table-widget.component.html',
  styleUrls: ['./multi-table-widget.component.scss']
})
export class MultiTableWidgetComponent extends TableWidgetComponent implements OnInit {
  constructor(elRef: ElementRef, stats: StatsService) {
    super(elRef, stats);
  }

  public loadData(): Promise<any> {
    const futures = this.settings.rows.map(row => this.loadRowData(row));
    return Promise.all(futures)
      .then(rows => this.processData(rows))
      .catch(err => {
        this.error = true;
        this.values = null;
        Log.log('MultiTableWidgetComponent', 'Error', err);
      });
  }

  private loadRowData(row: any): Promise<any> {
    const groupBy = this.settings.grouping ? [this.settings.grouping] : [];
    const filter = Object.assign({}, this.settings.filter, row.filter);
    return this.stats
      .fetchMetrics(row.metric, false, groupBy, filter, row.exclude, this.settings.from, this.settings.to)
      .then(data => this.stats.filterNullColumn(data, this.settings.grouping));
  }

  private processData(data: any[]): any {
    const grp = this.settings.grouping;

    const columnSet = new Set<string>();
    if (grp) {
      data.forEach(row => row.forEach(entry => columnSet.add(entry[grp])));
    }

    const columnNames = Array.from(columnSet)
      .filter(col => col != null && col !== '')
      .sort();
    const rowNames = this.settings.rows.map(row => row.title);

    const values: any = {};

    if (columnNames.length == 0) {
      columnNames.push(null);
    }

    for (const col of columnNames) {
      const rowContent: any = {};
      for (let row = 0; row < this.settings.rows.length; row++) {
        const entry = data[row].find(e => e[grp] == col);
        rowContent[rowNames[row]] = entry ? entry[MetricAttrMap[this.settings.rows[row].metric]] : '';
      }
      values[col] = rowContent;
    }

    return {
      rows: rowNames,
      columns: columnNames,
      values
    };
  }
}
